<template lang="pug">
.form-work-with-us-wrap
  v-form.form-work-with-us(ref="form")
    v-text-field(
      :rules="[rules.required]",
      name="name",
      label="Nome",
      background-color="white",
      color="primary",
      outlined,
      dense,
      hide-details
    )
    v-text-field(
      :rules="[rules.required, rules.email]",
      color="primary",
      name="email",
      type="email",
      label="E-mail",
      background-color="white",
      outlined,
      dense,
      hide-details
    )
    v-text-field(
      v-mask="['(##) ####-####', '(##) #####-####']",
      :rules="[rules.required, rules.phone]",
      color="primary",
      name="tel",
      type="tel",
      label="Telefone",
      background-color="white",
      outlined,
      dense,
      hide-details
    )
    v-file-input(
      :rules="[rules.required]",
      color="primary",
      name="attachment",
      label="Anexar currículo",
      background-color="white",
      accept=".doc,.docx,application/msword,application/pdf",
      outlined,
      dense,
      hide-details
    )
    .d-flex.justify-end
      v-btn.font-weight-bold.text-capitalize.px-8(
        @click="submit",
        color="primary",
        depressed
      ) Enviar
    float-alert(:value="success", v-if="success", color="green") Sua mensagem foi enviada com sucesso.
    float-alert(:value="error", v-if="error", color="red") Aconteceu um erro ao enviar a mensagem.
  v-overlay(:value="loading")
    v-progress-circular(indeterminate, size="64")
</div>
</template>

<script>
import { mask } from "vue-the-mask";
import FloatAlert from "@/components/tools/FloatAlert";
import { required, email, phone } from "./rules";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    rules: {
      required,
      email,
      phone,
    },
    loading: false,
    error: false,
    success: false,
  }),
  methods: {
    submit() {
      const form = this.$refs.form;
      if (form.validate()) {
        this.loading = true;
        this.error = false;
        this.success = false;

        fetch(this.action, {
          method: "POST",
          body: new FormData(form.$el),
        })
          .then((r) => {
            if (r.ok) {
              this.success = true;
              form.reset();
            } else throw new Error(r.status);
          })
          .catch(() => (this.error = true))
          .finally(() => (this.loading = false));
      }
    },
  },
  directives: {
    mask,
  },
  components: {
    FloatAlert,
  },
};
</script>

<style>
.form-work-with-us {
  background: transparent;
  width: 36 0px;
  display: grid;
  grid-template-columns: auto;
  gap: 12px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 7px;
}

@media screen and (max-width: 960px) {
  .form-work-with-us-wrap {
    width: 100%;
  }
}
</style>
